
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-partners",
      function () {
        return require("private-next-pages/referral-partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral-partners"])
      });
    }
  